import { type AssignedMedia } from '~/common/schemas/media'

export function getMediaIDSet(media?: AssignedMedia[] | null) {
    return new Set(media?.filter((m) => !!m.id)?.map((m) => m.id) ?? []) as Set<number>
}

export function getMediaNameSet(media?: AssignedMedia[] | null) {
    return new Set(media?.filter((m) => !!m.name)?.map((m) => m.name) ?? []) as Set<string>
}
